const home_safeties = {
  "en_translation_mapping": {
    "煙感知器": "Smoke detectors",
    "一酸化炭素警報機": "Carbon monoxide warning machine",
    "救急箱": "First aid kit",
    "防災カード": "Disaster Card",
    "消火器": "Fire extinguisher"
  },
  "zh-TW_translation_mapping": {
    "煙感知器": "煙霧探測器",
    "一酸化炭素警報機": "一氧化碳報警器",
    "救急箱": "急救箱",
    "防災カード": "防災卡",
    "消火器": "滅火器"
  }
}

export default home_safeties
